import { useEffect, useState } from 'react';

let cached = null;
let pending = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(cached));

export const refreshAIStatus = async (api) => {
  if (!pending) {
    pending = api.get('/ai/status')
      .then((res) => { cached = res.data; })
      .catch(() => { cached = { enabled: false, quota: 0, remaining: 0, used_today: 0 }; })
      .finally(() => { pending = null; notify(); });
  }
  return pending;
};

export const setAIRemaining = (remaining) => {
  if (cached) { cached = { ...cached, remaining }; notify(); }
};

export const useAIStatus = (api) => {
  const [status, setStatus] = useState(cached);
  useEffect(() => {
    listeners.add(setStatus);
    if (!cached && api) refreshAIStatus(api);
    return () => listeners.delete(setStatus);
  }, [api]);
  return status;
};
